import { DEFAULT_TABLE_PAGE_SIZE } from 'src/constants/Pagination';

import { type RegionTaskPageState } from './types';

export const initialState: RegionTaskPageState = {
  tableData: [],
  filteredTableData: [],
  currentPage: 1,
  totalPages: 0,
  perPage: DEFAULT_TABLE_PAGE_SIZE,
  searchField: '',
  regions: [],
  selectedRegion: {
    id: 0,
    name: '',
    country: '',
    formName: '',
    isActive: false,
    description: '',
  },
  selectedRegionTasks: [],
  selectedRegionTask: null,
  isRestrictionFormTableFilterOpen: false,
  restrictionFormTableFilterOptions: {
    stateRegions: [],
    applicableCountries: [],
    formNames: [],
    isActiveSelections: [],
  },
  restrictionFormTableFilter: {
    stateRegions: [],
    applicableCountries: [],
    formNames: [],
    isActiveSelections: [],
  },
  restrictionFormTableFilterTags: [],
};
